import { RespCategory } from '@vas2t-lowcode/api';
import { ref } from 'vue';

/** 缓存选中的模板id，仅用于首次渲染 */
let _selectedTemplate: RespCategory | undefined;

/** 设置选中的模板id */
export const setSelectedTemplate = (data?: RespCategory) => {
  _selectedTemplate = data;
};

export const getSelectedTemplate = () => {
  return _selectedTemplate;
};
